import { Link } from "react-router-dom";
import { COMPANY, NAV_LINKS, telLink, buildWhatsAppLink } from "../lib/site";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-32 border-t border-white/5 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <img
              src={COMPANY.logo}
              alt="S Mahadeva Properties"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </div>
          <p className="text-white/60 font-light leading-relaxed max-w-md">
            A trusted advisory dedicated to helping investors discover
            high-potential opportunities in Dholera Smart City &mdash; India&apos;s
            first greenfield smart city.
          </p>
          <div className="mt-8 flex gap-3">
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="px-5 py-3 text-xs tracking-[0.2em] uppercase border border-[#25D366]/60 text-[#25D366] hover:bg-[#25D366]/10 transition-all"
            >
              WhatsApp
            </a>
            <a
              href={telLink(COMPANY.phones[1])}
              data-testid="footer-call"
              className="px-5 py-3 text-xs tracking-[0.2em] uppercase border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all"
            >
              Call
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="eyebrow mb-6">Navigate</div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  data-testid={`footer-nav-${l.name.toLowerCase()}`}
                  className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm tracking-wide"
                >
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="eyebrow mb-6">Get in touch</div>
          <ul className="space-y-4 text-sm text-white/70">
            {COMPANY.phones.map((p) => (
              <li key={p} className="flex items-center gap-3">
                <Phone
                  className="w-4 h-4 text-[#D4AF37]"
                  strokeWidth={1.4}
                />
                <a
                  href={telLink(p)}
                  className="font-mono hover:text-[#D4AF37] transition-colors"
                >
                  {p}
                </a>
              </li>
            ))}
            <li className="flex items-center gap-3">
              <Mail
                className="w-4 h-4 text-[#D4AF37]"
                strokeWidth={1.4}
              />
              <a
                href={`mailto:${COMPANY.email}`}
                className="hover:text-[#D4AF37] transition-colors break-all"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle
                className="w-4 h-4 text-[#D4AF37]"
                strokeWidth={1.4}
              />
              <a
                href={buildWhatsAppLink()}
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#D4AF37] transition-colors"
              >
                WhatsApp: {COMPANY.whatsappDisplay}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin
                className="w-4 h-4 text-[#D4AF37]"
                strokeWidth={1.4}
              />
              <span>{COMPANY.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-8 px-6 md:px-10 max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs tracking-[0.2em] uppercase text-white/40">
          © {new Date().getFullYear()} S Mahadeva Properties. All rights
          reserved.
        </p>
        <p className="text-xs tracking-[0.2em] uppercase text-white/40">
          Founder · Sneha Dixit
        </p>
      </div>
    </footer>
  );
}
